// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.users .user-table {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}
.users .add-button Button {
  color: #fff;
  background: #2b2b81;
  margin: 10px 50px;
  padding: 10px 15px;
  font-weight: 550;
  border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/User/ShowUser/show.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AAAJ;AAII;EACE,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAFN","sourcesContent":[".users{\n  .user-table{\n    display: flex;\n    justify-content: center;\n    margin-top: 15px;\n  }\n  \n  .add-button{\n    Button{\n      color:  #fff;\n      background: #2b2b81;\n      margin: 10px 50px;\n      padding: 10px 15px;\n      font-weight: 550;\n      border-radius: 10px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
